import glyphMap from "@react-native-vector-icons/material-design-icons/glyphmaps/MaterialDesignIcons.json";
import type { MaterialDesignIconsIconName } from "@react-native-vector-icons/material-design-icons/static";
import {
	type CustomLevelIconName,
	isCustomLevelIconName,
} from "./icons/custom-level-icon-names";

export type IconType = MaterialDesignIconsIconName;

export const isIconType = (value: string): value is IconType =>
	value in glyphMap;

export type LevelIconName = IconType | CustomLevelIconName;

export const isLevelIconName = (value: string): value is LevelIconName =>
	isCustomLevelIconName(value) || isIconType(value);
